import React from "react";
import { StyleSheet, View, Text } from "react-native";
import { colors } from "src/assets";

type Props = {
  value: number;
};

export const Price: React.FC<Props> = ({ value }) => {
  return (
    <View style={styles.container}>
      <Text style={styles.text1}>
        ¥<Text style={styles.text2}>{value}</Text> /{" "}
        <Text style={styles.text2}>1</Text>分
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
  },
  text1: {
    fontSize: 12,
    color: colors.chokuRed,
  },
  text2: {
    fontSize: 14,
    fontWeight: "bold",
  },
});
